import '../styles/index.scss';
import '../../public/Acronis-Light.woff';
import '../../public/Acronis.woff';/*
import '../assets/logo.svg';
import '../assets/menu_logo.png';
import '../assets/award-cnr.png';
import '../assets/award-gartner-peer.png';
import '../assets/diamond.png';
import '../assets/wheel.png';
import '../assets/lock.png';
import '../assets/report-image.png';
import '../assets/WP_Acronis_Cyber_Threats_Report_2020_EN-US_201201.pdf';*/

if (process.env.NODE_ENV === 'development') {
  require('../index.html');
}

function downloadURI(uri, name) {
  var link = document.createElement("a");
  link.setAttribute('download', name);
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function setBusy(status) {

}

$(function () {
  var src = { "Afghanistan": "af", "Albania": "al", "Algeria": "dz", "Andorra": "ad", "Angola": "ao", "Antigua and Barbuda": "ag", "Argentina": "ar", "Armenia": "am", "Australia": "au", "Austria": "at", "Azerbaijan": "az", "Bahamas": "bs", "Bahrain": "bh", "Bangladesh": "bd", "Barbados": "bb", "Belarus": "by", "Belgium": "be", "Belize": "bz", "Benin": "bj", "Bhutan": "bt", "Bolivia (Plurinational State of)": "bo", "Bosnia and Herzegovina": "ba", "Botswana": "bw", "Brazil": "br", "Brunei Darussalam": "bn", "Bulgaria": "bg", "Burkina Faso": "bf", "Burundi": "bi", "Cabo Verde": "cv", "Cambodia": "kh", "Cameroon": "cm", "Canada": "ca", "Central African Republic": "cf", "Chad": "td", "Chile": "cl", "China": "cn", "Colombia": "co", "Comoros": "km", "Congo": "cg", "Congo, Democratic Republic of the": "cd", "Costa Rica": "cr", "Côte d'Ivoire": "ci", "Croatia": "hr", "Cuba": "cu", "Cyprus": "cy", "Czechia": "cz", "Denmark": "dk", "Djibouti": "dj", "Dominica": "dm", "Dominican Republic": "do", "Ecuador": "ec", "Egypt": "eg", "El Salvador": "sv", "Equatorial Guinea": "gq", "Eritrea": "er", "Estonia": "ee", "Eswatini": "sz", "Ethiopia": "et", "Fiji": "fj", "Finland": "fi", "France": "fr", "Gabon": "ga", "Gambia": "gm", "Georgia": "ge", "Germany": "de", "Ghana": "gh", "Greece": "gr", "Grenada": "gd", "Guatemala": "gt", "Guinea": "gn", "Guinea-Bissau": "gw", "Guyana": "gy", "Haiti": "ht", "Honduras": "hn", "Hungary": "hu", "Iceland": "is", "India": "in", "Indonesia": "id", "Iran (Islamic Republic of)": "ir", "Iraq": "iq", "Ireland": "ie", "Israel": "il", "Italy": "it", "Jamaica": "jm", "Japan": "jp", "Jordan": "jo", "Kazakhstan": "kz", "Kenya": "ke", "Kiribati": "ki", "Korea (Democratic People's Republic of)": "kp", "Korea, Republic of": "kr", "Kuwait": "kw", "Kyrgyzstan": "kg", "Lao People's Democratic Republic": "la", "Latvia": "lv", "Lebanon": "lb", "Lesotho": "ls", "Liberia": "lr", "Libya": "ly", "Liechtenstein": "li", "Lithuania": "lt", "Luxembourg": "lu", "Madagascar": "mg", "Malawi": "mw", "Malaysia": "my", "Maldives": "mv", "Mali": "ml", "Malta": "mt", "Marshall Islands": "mh", "Mauritania": "mr", "Mauritius": "mu", "Mexico": "mx", "Micronesia (Federated States of)": "fm", "Moldova, Republic of": "md", "Monaco": "mc", "Mongolia": "mn", "Montenegro": "me", "Morocco": "ma", "Mozambique": "mz", "Myanmar": "mm", "Namibia": "na", "Nauru": "nr", "Nepal": "np", "Netherlands": "nl", "New Zealand": "nz", "Nicaragua": "ni", "Niger": "ne", "Nigeria": "ng", "North Macedonia": "mk", "Norway": "no", "Oman": "om", "Pakistan": "pk", "Palau": "pw", "Panama": "pa", "Papua New Guinea": "pg", "Paraguay": "py", "Peru": "pe", "Philippines": "ph", "Poland": "pl", "Portugal": "pt", "Qatar": "qa", "Romania": "ro", "Russian Federation": "ru", "Rwanda": "rw", "Saint Kitts and Nevis": "kn", "Saint Lucia": "lc", "Saint Vincent and the Grenadines": "vc", "Samoa": "ws", "San Marino": "sm", "Sao Tome and Principe": "st", "Saudi Arabia": "sa", "Senegal": "sn", "Serbia": "rs", "Seychelles": "sc", "Sierra Leone": "sl", "Singapore": "sg", "Slovakia": "sk", "Slovenia": "si", "Solomon Islands": "sb", "Somalia": "so", "South Africa": "za", "South Sudan": "ss", "Spain": "es", "Sri Lanka": "lk", "Sudan": "sd", "Suriname": "sr", "Sweden": "se", "Switzerland": "ch", "Syrian Arab Republic": "sy", "Tajikistan": "tj", "Tanzania, United Republic of": "tz", "Thailand": "th", "Timor-Leste": "tl", "Togo": "tg", "Tonga": "to", "Trinidad and Tobago": "tt", "Tunisia": "tn", "Turkey": "tr", "Turkmenistan": "tm", "Tuvalu": "tv", "Uganda": "ug", "Ukraine": "ua", "United Arab Emirates": "ae", "United Kingdom of Great Britain and Northern Ireland": "gb", "United States of America": "us", "Uruguay": "uy", "Uzbekistan": "uz", "Vanuatu": "vu", "Venezuela (Bolivarian Republic of)": "ve", "Viet Nam": "vn", "Yemen": "ye", "Zambia": "zm", "Zimbabwe": "zw" };

  $('*[data-autocomplete]').autocomplete({
    source: src,
    highlightClass: 'text-success',
    treshold: 2,
  });

  $("body").show();

  window.addEventListener('load', function () {
    var forms = document.getElementsByClassName('needs-validation');
    var validation = Array.prototype.filter.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }, false);

  function log(text) {
    console.log(text);
  }

  function showMessage(text) {
    console.error(text);
  }

  $("#main-form").on("submit", function (e) {

    e.preventDefault();

    if (!$("#privacy").is(':checked')) return;

    var formId = 1144;

    setBusy(true);

    $("#downloadButton").prop("disabled", true);

    $.post("https://digipa.it/wp-json/contact-form-7/v1/contact-forms/" + formId + "/feedback", {
      _wpcf7_locale: 'it_IT',
      'first-name': $("#first-name").val(),
      'last-name': $("#last-name").val(),
      'email': $("#email").val(),
      'phone': $("#phone").val(),
      'company': $("#company").val(),
      'job-title': $("#job-title").val(),
      'country': $("#country").val(),
      'type': $("#type").val(),
      'product-title': $("#product-title").val()
    }, "multipart/form-data").done(function (res) {
      setBusy(false);
      if (res.status == "mail_sent") {

        fbq('track', 'CompleteRegistration', { content_name: 'Acronis Cyberthreats' });
        downloadURI('/public/WP_Acronis_Cyber_Threats_Report_2020_EN-US_201201.pdf', 'WP_Acronis_Cyber_Threats_Report_2020_EN-US_201201.pdf');
        $("#main-form").trigger("reset");
        
        setTimeout(function () {
          
          window.location.reload();
        }, 3000);

      } else {
        showMessage("An error occurred during submit, retry later please.");
      }
    }).fail(function (err) {
      setBusy(false);
      showMessage("An error occurred during submit, retry later please.");
    });

  });

});

